import { render, staticRenderFns } from "./MarksGeneral.vue?vue&type=template&id=c4772a68&"
import script from "./MarksGeneral.vue?vue&type=script&lang=js&"
export * from "./MarksGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports